module.exports = __webpack_public_path__ + "valves_close_work.svg?0dd0181787169d0fc1815c734cdc6f3e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map_icons/valves_close_work.svg
// module id = 625
// module chunks = 0